import { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import css from './JumperButtons.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JumperButtons = function JumperButtons(_ref) {
  var buttons = _ref.buttons,
      currentIndex = _ref.currentIndex,
      _onClick = _ref.onClick,
      title = _ref.title;
  var wrapEl = useRef(null);
  var firstChildEl = useRef(null);
  useEffect(function () {
    var _wrapEl$current;

    var left = firstChildEl.current.offsetWidth * currentIndex;
    if ((_wrapEl$current = wrapEl.current) !== null && _wrapEl$current !== void 0 && _wrapEl$current.scrollTo) wrapEl.current.scrollTo({
      left: left,
      behavior: 'smooth'
    });
  }, [currentIndex]);
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    id: "jump-nav",
    children: [title && /*#__PURE__*/_jsx("div", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: css.buttons,
      ref: wrapEl,
      children: /*#__PURE__*/_jsx("div", {
        className: css.wrap,
        children: buttons.map(function (_ref2, idx) {
          var buttonTitle = _ref2.title,
              slug = _ref2.slug;
          return /*#__PURE__*/_jsx("div", {
            className: css.button,
            ref: idx === 0 ? firstChildEl : null,
            children: /*#__PURE__*/_jsx("a", {
              "aria-label": "Anchor further down the page to ".concat(buttonTitle, " section"),
              href: "#".concat(slug),
              onClick: function onClick() {
                return _onClick(idx);
              },
              children: buttonTitle
            })
          }, slug);
        })
      })
    })]
  });
};

JumperButtons.displayName = 'JumperButtons';
JumperButtons.defaultProps = {
  title: false
};
JumperButtons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape).isRequired,
  currentIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default /*#__PURE__*/memo(JumperButtons);